<div class="header">
    <span class="title">Questionário</span>
    <span class="status">
      <span class="punctuation" *ngIf="currentTest.status === 'evaluated'">
        {{ totalCorrectAnswers }} / {{ totalQuestions }}
      </span>
      <span class="note" *ngIf="currentTest.status === 'evaluated'">
        Pontuação
      </span>
    </span>
</div>

<mat-dialog-content>

    <span class="mat-h3" *ngIf="currentTest.status !== 'pending'" style="color: #093">
        Já respondido
    </span>

    <form [formGroup]="formQuestions">
        
        <ng-container formArrayName="questions">
            <ng-container *ngFor="let control of Questions.controls; let i = index">
                <fieldset [formGroupName]="i" style="margin-top: 20px">
                    <legend>Pergunta Nº {{i + 1}} - <ng-container *ngIf="this.currentTest.status === 'evaluated'">
                        <span *ngIf="getAnsweredQuestion(questions[i])" style="color: #093">Correto</span>
                        <span *ngIf="!getAnsweredQuestion(questions[i])" style="color: red">Incorreto</span>
                    </ng-container></legend>

                    <span class="enunciated">
                        {{ questions[i].description }}
                    </span>
                    
                    <ng-container>
                                              
                        <ng-container [ngSwitch]="questions[i].type">
                            <!-- <ng-container *ngSwitchCase="'option'">                                
                                <mat-action-list>
                                    <button mat-list-item
                                        *ngFor="let option of questions[i].options"
                                        [disabled]="this.currentTest.status !== 'pending'"
                                        [ngClass]="{ 
                                            selected: (control.get('response').value || []).includes(option.id),
                                            correct: option.is_right == 1 && currentTest.status !== 'pending',
                                            incorrect: option.is_right == 0 && currentTest.status !== 'pending' 
                                        }"
                                        (click)="setOption(control, option, questions[i])">
                                        <h3 matLine>{{ option.description }}</h3>
                                        <p matLine *ngIf="currentTest.status === 'pending'">clique para escolher</p>
                                        <p matLine *ngIf="currentTest.status !== 'pending' && getAnsweredQuestion(questions[i], option) == option.id">Sua resposta</p>
                                        <p matLine *ngIf="currentTest.status !== 'pending' && option.is_right == 1">Resposta correta</p>
                                    </button>
                                </mat-action-list>
                                <ng-container *ngIf="this.currentTest.status === 'evaluated'">
                                    <span *ngIf="getAnsweredQuestion(questions[i])" style="color: #093">Correto</span>
                                    <span *ngIf="!getAnsweredQuestion(questions[i])" style="color: red">Incorreto</span>
                                </ng-container>
                            </ng-container> -->
                            <ng-container *ngSwitchCase="'option'">
                                <mat-action-list>
                                    <div *ngFor="let option of questions[i].options" class="space">
                                        <mat-checkbox
                                            (change)="setOption(control, option, questions[i])"
                                            [value]="option.id"
                                            [disabled]="this.currentTest.status !== 'pending'"
                                            [ngClass]="{
                                                selected: (control.get('response').value || []).includes(option.id),
                                                correct: option.is_right == 1 && currentTest.status === 'evaluated',
                                                incorrect: option.is_right == 0 && currentTest.status === 'evaluated'
                                            }"
                                            [checked]="getAnsweredQuestion(questions[i], option) == option.id && currentTest.status !== 'pending'">
                                            {{ option.description }}
                                            <!-- <p *ngIf="currentTest.status === 'pending'">clique para escolher</p> -->
                                            <!-- <p *ngIf="currentTest.status !== 'pending' && getAnsweredQuestion(questions[i], option) == option.id">Sua resposta</p>
                                            <p *ngIf="currentTest.status !== 'pending' && option.is_right == 1">Resposta correta</p> -->
                                        </mat-checkbox>
                                    </div>
                                </mat-action-list>
                            </ng-container>                            
                            <ng-container *ngSwitchCase="'multiple'">                                    
                                <mat-grid-list [cols]="columns$ | async" [rowHeight]="rowHeight$ | async" style="padding-top: 8px;"> 
                                    <mat-grid-tile *ngFor="let option of questions[i].options">
                                        <!--<mat-checkbox color="primary" (change)="onChangeMultiple(control, $event)" [value]="option.id" 
                                            [disabled]="this.currentTest.status !== 'pending'"
                                            [ngClass]="{
                                                correct: getIsCorrect(questions[i], option) && this.currentTest.status === 'evaluated',
                                                incorrect: (!getIsCorrect(questions[i], option)) && this.currentTest.status === 'evaluated'
                                            }"
                                            [checked]="getAnsweredQuestion(questions[i], option) == option.id && currentTest.status !== 'pending'">{{ option.description }}</mat-checkbox>-->
                                        <mat-checkbox color="primary" (change)="onChangeMultiple(control, $event);setOption(control,option, questions[i])" [value]="option.id" 
                                            [disabled]="this.currentTest.status !== 'pending'"
                                            [ngClass]="{
                                                correct: option.is_right == 1 && this.currentTest.status === 'evaluated',
                                                incorrect: option.is_right == 0 && this.currentTest.status === 'evaluated'
                                            }"
                                            [checked]="getAnsweredQuestion(questions[i], option) == option.id && currentTest.status !== 'pending'">{{ option.description }}</mat-checkbox>
                                    </mat-grid-tile>
                                </mat-grid-list>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <div class="row">
                                    <mat-form-field appearance="outline">
                                        <textarea formControlName="response" matInput [readonly]="this.currentTest.status !== 'pending'" rows="5"></textarea>
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </ng-container>

                    </ng-container>                   

                </fieldset>

            </ng-container>
        </ng-container>

    </form>

</mat-dialog-content>
<mat-progress-bar mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button mat-button color="warn" mat-dialog-close>Fechar</button>
    <button mat-raised-button color="primary" (click)="submitQuestion()"
        [disabled]="formQuestions.invalid || this.currentTest.status !== 'pending'">Salvar</button>
</mat-dialog-actions>